/**
 * @file 全景流
 * @author liuyanan06
 */
import Vue from 'vue';
import Router from 'vue-router';
import '@/common/style/index.scss';

Vue.use(Router);

const routes = [
    {
        path: '/',
        name: 'NewMain',
        component: () => import(/* webpackChunkName: "NewMain" */ './views/NewMain/index.vue'),
        meta: {
            title: '3D实景',
            keepAlive: true
        }
    },
    {
        path: '/feedback',
        name: 'FeedBack',
        component: () => import(/* webpackChunkName: "FeedBack" */ './views/FeedBack/FeedBack.vue'),
        meta: {
            title: '问题反馈'
        }
    },
    {
        path: '/theme',
        name: 'Theme',
        component: () => import(/* webpackChunkName: "Theme" */ './views/Theme/Theme.vue'),
        meta: {
            title: '百度地图全景社区'
        }
    },
    {
        path: '/rankdetail',
        name: 'RankDetail',
        component: () => import(/* webpackChunkName: "RankDetail" */ './views/RankDetail/RankDetail.vue'),
        meta: {
            title: '3D实景'
        }
    },
    {
        path: '/detail',
        name: 'Detail',
        component: () => import(/* webpackChunkName: "Detail" */ './views/Detail/Detail.vue'),
        meta: {
            title: '3D实景'
        }
    }, {
        path: '/homepage',
        name: 'HomePage',
        component: () => import(/* webpackChunkName: "HomePage" */ './views/HomePage/index.vue'),
        meta: {
            title: '个人主页'
        }
    },
    {
        path: '/oldMain',
        name: 'Main',
        component: () => import(/* webpackChunkName: "Main" */ './views/Main/Main.vue'),
        meta: {
            title: '3D实景',
            keepAlive: true
        }
    },
    {
        path: '/upload',
        name: 'Upload',
        component: () => import(/* webpackChunkName: "Upload" */ './views/Upload/index'),
        meta: {
            title: '上传全景图片'
        }
    },

    // FIXME: 测试路由
    {
        path: '/video-demo',
        name: 'VideoDemo',
        component: () => import(/* webpackChunkName: "VideoDemo" */ './views/Demo/video'),
        meta: {
            title: '视频测试'
        }
    }
];

const router = new Router({
    routes
});

router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    next();
});

export default router;